import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Collapsible, getTestId, isValidObject, Radio, StateConfigContext, Typography } from '@airtel/air-design-system';
import { debounce, merge } from 'lodash';
import { useCallback, useContext, useEffect, useMemo, useState } from 'react';
import { View } from 'react-native';
import { LinkListItemWidget } from '../link-list-item-widget';
import { serviceSelectionStepWidgetConfig, successAvatarConfig } from './ServiceSelectionStepWidgetConfig';
import { getServiceSelectionStepWidgetStyles } from './ServiceSelectionStepWidgetStyles';
export var ServiceSelectionStepWidgetComponent = props => {
  var _useContext = useContext(StateConfigContext),
    theme = _useContext.theme;
  var _useMemo = useMemo(() => merge({}, serviceSelectionStepWidgetConfig, props), [serviceSelectionStepWidgetConfig, props]),
    id = _useMemo.id,
    isExpanded = _useMemo.isExpanded,
    state = _useMemo.state,
    successStateHeading = _useMemo.successStateHeading,
    onUserAction = _useMemo.onUserAction,
    onStepDetailsListItemPressMetaData = _useMemo.onStepDetailsListItemPressMetaData,
    onStepDetailsCtaPressMetaData = _useMemo.onStepDetailsCtaPressMetaData,
    autoFormSubmitDebounceDelay = _useMemo.autoFormSubmitDebounceDelay,
    isAutoFormSubmitDebounceAllowed = _useMemo.isAutoFormSubmitDebounceAllowed,
    testID = _useMemo.testID,
    stepDetailsProps = _useMemo.stepDetailsProps,
    radioInputProps = _useMemo.radioInputProps,
    checkedRadioId = _useMemo.checkedRadioId,
    checkedSubRadioId = _useMemo.checkedSubRadioId,
    subRadioTitle = _useMemo.subRadioTitle,
    onMainRadioPressMetaData = _useMemo.onMainRadioPressMetaData,
    onSubRadioPressMetaData = _useMemo.onSubRadioPressMetaData,
    onValidFormMetaData = _useMemo.onValidFormMetaData;
  var serviceSelectionStepWidgetStyles = getServiceSelectionStepWidgetStyles();
  var _useState = useState(isExpanded),
    isExpandedState = _useState[0],
    setIsExpandedState = _useState[1];
  var _useState2 = useState(state),
    stateType = _useState2[0],
    setStateType = _useState2[1];
  var _useState3 = useState(checkedRadioId),
    checkedRadioIdState = _useState3[0],
    setCheckedRadioIdState = _useState3[1];
  var _useState4 = useState(checkedSubRadioId),
    checkedSubRadioIdState = _useState4[0],
    setCheckedSubRadioIdState = _useState4[1];
  var radioButtons = radioInputProps === null || radioInputProps === void 0 ? void 0 : radioInputProps.radioButtons;
  var isSuccessState = stateType === 'success';
  useEffect(() => {
    setIsExpandedState(isExpanded);
  }, [isExpanded]);
  var onPressHandler = radioButtonId => {
    setStateType('none');
    setCheckedRadioIdState(radioButtonId);
    setCheckedSubRadioIdState('');
    isValidObject(onMainRadioPressMetaData) && (onUserAction === null || onUserAction === void 0 ? void 0 : onUserAction(Object.assign({
      id
    }, onMainRadioPressMetaData), {
      value: radioButtonId
    }));
  };
  var onSubRadioPressHandler = subRadio => {
    var subRadioButtonId = subRadio === null || subRadio === void 0 ? void 0 : subRadio.id;
    setCheckedSubRadioIdState(subRadioButtonId);
    if (subRadioButtonId) {
      isValidObject(onSubRadioPressMetaData) && (onUserAction === null || onUserAction === void 0 ? void 0 : onUserAction(Object.assign({
        id
      }, onSubRadioPressMetaData), {
        value: subRadioButtonId
      }));
      isValidObject(subRadio === null || subRadio === void 0 ? void 0 : subRadio.onPressMetaData) && (onUserAction === null || onUserAction === void 0 ? void 0 : onUserAction(Object.assign({
        id
      }, subRadio === null || subRadio === void 0 ? void 0 : subRadio.onPressMetaData), {
        value: subRadioButtonId
      }));
      handleValidation(checkedRadioIdState, subRadioButtonId);
    }
  };
  var getSubRadioButtons = mainRadioId => {
    var _a;
    var radio = (_a = radioInputProps === null || radioInputProps === void 0 ? void 0 : radioInputProps.radioButtons) === null || _a === void 0 ? void 0 : _a.find(radio => radio.id === mainRadioId);
    return (radio === null || radio === void 0 ? void 0 : radio.subRadioButtons) || [];
  };
  var useDebouncedFunction = (callback, delay) => {
    return useCallback(debounce(callback, delay), [callback, delay]);
  };
  var functionDebounce = useDebouncedFunction((metaData, mainRadioId, subRadioId) => {
    onUserAction === null || onUserAction === void 0 ? void 0 : onUserAction(Object.assign({
      id
    }, metaData), {
      value: mainRadioId,
      subValue: subRadioId
    });
  }, autoFormSubmitDebounceDelay);
  var handleValidation = (mainRadioId, subRadioId) => {
    if (isValidObject(onValidFormMetaData)) {
      if (isAutoFormSubmitDebounceAllowed) {
        functionDebounce(onValidFormMetaData, mainRadioId, subRadioId);
      } else {
        onUserAction === null || onUserAction === void 0 ? void 0 : onUserAction(Object.assign({
          id
        }, onValidFormMetaData), {
          value: mainRadioId,
          subValue: subRadioId
        });
      }
    }
    setStateType('success');
  };
  var getSubHeading = checkedSubRadioId => {
    var subRadio = getSubRadioButtons(checkedRadioIdState).find(subRadio => subRadio.id === checkedSubRadioId);
    return (subRadio === null || subRadio === void 0 ? void 0 : subRadio.label) || '';
  };
  var onListItemPressHandler = () => {
    setIsExpandedState(_isExpandedState => !_isExpandedState);
  };
  return _jsx(Collapsible, Object.assign({
    theme: theme,
    childPaddingToken: "SPACING_0",
    titlePaddingToken: "SPACING_0",
    showIcon: false,
    withCard: true,
    isExpanded: isExpandedState
  }, getTestId(testID, 'Collapsible'), {
    titleComponent: _jsx(View, Object.assign({
      style: serviceSelectionStepWidgetStyles.titleComponent
    }, {
      children: _jsx(LinkListItemWidget, Object.assign({}, stepDetailsProps, isSuccessState && !isExpandedState && successStateHeading && {
        heading: successStateHeading
      }, {
        theme: theme,
        roundedCorners: true,
        noHoverEffect: true,
        noPressEffect: true
      }, getTestId(testID, 'LinkListItemWidget'), {
        actionTypeProps: !isExpandedState && (stepDetailsProps === null || stepDetailsProps === void 0 ? void 0 : stepDetailsProps.actionTypeProps)
      }, isSuccessState && Object.assign({}, successAvatarConfig), isSuccessState && !isExpandedState && {
        subHeading: getSubHeading(checkedSubRadioIdState)
      }, {
        onUserAction: onUserAction,
        onPress: onStepDetailsListItemPressMetaData,
        actionTypeOnPressMetaData: onStepDetailsCtaPressMetaData,
        onPressHandler: onListItemPressHandler
      }))
    }))
  }, {
    children: _jsxs(View, Object.assign({
      style: serviceSelectionStepWidgetStyles.content
    }, {
      children: [_jsx(View, Object.assign({
        style: serviceSelectionStepWidgetStyles.mainRadioContainer
      }, {
        children: radioButtons === null || radioButtons === void 0 ? void 0 : radioButtons.map((radioButton, index) => {
          return _jsx(Radio, Object.assign({}, radioButton, {
            checked: (radioButton === null || radioButton === void 0 ? void 0 : radioButton.checked) || (radioButton === null || radioButton === void 0 ? void 0 : radioButton.id) === checkedRadioIdState,
            onPress: () => onPressHandler(radioButton === null || radioButton === void 0 ? void 0 : radioButton.id)
          }), "radio_group_item_" + (radioButton === null || radioButton === void 0 ? void 0 : radioButton.id) + "_" + index);
        })
      })), checkedRadioIdState && _jsxs(View, Object.assign({
        style: serviceSelectionStepWidgetStyles.subContainer
      }, {
        children: [_jsx(Typography, Object.assign({
          style: serviceSelectionStepWidgetStyles.subRadioTitle,
          text: subRadioTitle,
          type: "body-single-line-xs"
        }, getTestId(testID, 'title'))), _jsx(View, Object.assign({
          style: serviceSelectionStepWidgetStyles.subRadioContainer
        }, {
          children: getSubRadioButtons(checkedRadioIdState).map((subRadio, index) => _jsx(Radio, Object.assign({
            style: index !== 0 && serviceSelectionStepWidgetStyles.radio
          }, subRadio, {
            checked: (subRadio === null || subRadio === void 0 ? void 0 : subRadio.checked) || (subRadio === null || subRadio === void 0 ? void 0 : subRadio.id) === checkedSubRadioIdState,
            onPress: () => onSubRadioPressHandler(subRadio),
            labelPosition: "left"
          }), "sub_radio_group_item_" + (subRadio === null || subRadio === void 0 ? void 0 : subRadio.id) + "_" + index))
        }))]
      }))]
    }))
  }));
};
ServiceSelectionStepWidgetComponent.genericRendererKey = 'AirServiceSelectionStepWidget';